export const physiologyModule = {
  id: "physiology",
  title: "Colon Physiology",
  sections: [
    {
      type: "text",
      content:
        "<p>The colon absorbs water and electrolytes while forming and storing feces. This module covers colonic motility, absorption, and the role of gut microbiota.</p>",
    },
    {
      type: "text",
      content:
        "<p>Content coming soon. Add your physiology content here.</p>",
    },
  ],
};
